import { Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { ExpandableMinMaxFilterComponent, MinMaxFilterConfig } from "src/app/shared-components/expandable-min-max-filter/expandable-min-max-filter.component";
import { PriceFilterModel } from "./search-filter-price.model";

@Component({
    selector: "search-filter-price",
    imports: [ExpandableMinMaxFilterComponent],
    templateUrl: "./search-filter-price.component.html",
    styleUrl: "./search-filter-price.component.scss",
})
export class SearchFilterPriceComponent {
    filterForm = input.required<FieldTree<PriceFilterModel>>();
    caption: string = "mill";

    protected filterConfig = computed<MinMaxFilterConfig<PriceFilterModel>>(() => ({
        filterForm: this.filterForm,
        title: "Pris",
        fromFieldAccessor: (form) => form.priceFrom,
        toFieldAccessor: (form) => form.priceTo,
        expandedAccessor: (form) => form.expanded,
        fromFieldId: "priceFrom",
        toFieldId: "priceTo",
        cssClass: "price",
        caption: this.caption,
    }));
}
